import label from "fragments/vendors/label"
import { gql } from "graphql-tag"

const GET_LABELS_WAVE = gql`
  ${label}

  query getLabelsWave($query: GetWaveQueryLabels) {
    getLabelsWave(query: $query) {
      labels {
        ...Label
      }
      cursor
      hasPrevData
      hasNextData
      prevCursor
    }
  }
`

export default GET_LABELS_WAVE
